// 此文件运行在 Web Worker 环境中，无 DOM、无 Vue、无 window 对象
import reSetData from "@/axios/base";

async function secureFetch(url, options = {}) {
  const {
    baseURL = '',
    token = '',
    hosId = '',
    firmId = 'siv6k7x1',
    version = '1.3.7',
    clientType = 'A',
    method = 'POST',
    data = null,
    timeout = 50000,
  } = options;
  // 构建请求头（与原 axios 拦截器一致）
  const headers = {
    'Content-Type': 'application/json',
    version,
    firmId,
    clientType,
  };

  if (token) headers['Authorization'] = token;
  if (hosId !== undefined) headers['hosId'] = hosId;
  
  // 对业务数据进行安全封装
  const body = reSetData(data, token);
  // 超时控制器
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeout);

  try {
    // 拼接完整 URL（避免多余斜杠）
    const fullUrl = baseURL.replace(/\/+$/, '') + '/' + url.replace(/^\/+/, '');
    const res = await fetch(fullUrl, {
      method,
      headers,
      body: JSON.stringify(body),
      signal: controller.signal, // 关联超时信号
    });

    clearTimeout(timeoutId); // 成功则清除超时
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.json();
  } catch (err) {
    clearTimeout(timeoutId);
    throw err;
  }
}
// 将函数暴露给 Worker 全局作用域
// self.secureFetch = secureFetch;
export default secureFetch;